module.exports = __webpack_public_path__ + "img/logo.ca6f1568.png";